// Pure class composition for <Button>, split out so it is unit-testable without importing
// the component's CSS side-effect. The component is a thin shell over this.
//
// The house grammar shared by every primitive: variant (visual style) × tone (semantic
// color) × size. Color never lives in the variant — the tone class (.rc-tone-*, see
// tones.css) sets the palette slots and the variant decides which slots to read.
import { cn } from "./cn";
import type { Tone } from "./tone";

export type ButtonVariant = "solid" | "soft" | "outline" | "ghost";
export type ButtonTone = Tone;
export type ButtonSize = "sm" | "md" | "lg";

export function buttonClass(
  variant: ButtonVariant,
  tone: ButtonTone,
  size: ButtonSize,
  extra?: string,
): string {
  return cn("rc-button", `rc-button--${variant}`, `rc-tone-${tone}`, `rc-button--${size}`, extra);
}
